// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex-container[data-v-7b94bab8]{display:flex}.img-circle[data-v-7b94bab8]{max-height:200px;max-width:200px;border-radius:50%}.red-b[data-v-7b94bab8]{background-color:red}.average-font[data-v-7b94bab8]{font-size:1.3em}.non-overflow[data-v-7b94bab8]{overflow-y:auto}.change-profile-text[data-v-7b94bab8]{color:red;font-size:1.3em}", ""]);
// Exports
module.exports = exports;
